export const getRunByPlaceholderText = (isCoaEnabled: boolean): string => {
  return isCoaEnabled
    ? 'To run for a specific dimension(s), select a dimension first'
    : 'To run for a specific allocation(s), select an allocation structure level first';
};
